import React, { useEffect, useState } from 'react';

import { ELiveDataMetrics } from '~/src/dash/api/live_data/models';
import { getAllMonitors, getMonitor } from '~/src/dash/api/monitors/monitors_methods';
import { getMonitorCustomMetricsByPublisherID } from '~/src/dash/api/monitors/monitors_methods';
import { IMonitor, IMonitorCustomMetric } from '~/src/dash/api/monitors/monitors_models';
import {
  generateMonitorCustomMetricList,
  generateMonitorMetricMenuList,
  getSelectedMonitorCustomMetricFromList,
  TargetedMetricConditionCustom,
  TargetedMetricConditionSingle,
} from '~/src/dash/api/monitors/monitors_utils';
import { EditMonitor } from '~/src/dash/components/monitor/edit-monitor';
import { IStore } from '~/src/dash/reducers/store';
import { parseLocation } from '~/src/dash/router/routes';
import { IMenuList } from '~/src/dash/types/menuList';
import { IHistoryProps, ISessionStateProps, IUserStateProps } from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';
import { obfuscateMonitorName } from '~/src/dash/utils/obfuscate';
import { LoadingView } from '~/src/dash/views/loading-view';

export interface IProps extends ISessionStateProps, IUserStateProps, IHistoryProps {}

export function MonitorExistingViewInner(props: IProps) {
  const [allMonitors, setAllMonitors] = useState([] as IMonitor[]);
  const [fetchedAllMonitors, setFetchedAllMonitors] = useState(false);
  const [monitor, setMonitor] = useState(undefined as any as IMonitor);
  const [fetchedMonitor, setFetchedMonitor] = useState(false);
  const [monitorCustomMetrics, setMonitorCustomMetrics] = useState([] as IMonitorCustomMetric[]);
  const [fetchedCustomMetrics, setFetchedCustomMetrics] = useState(false);
  const loc = parseLocation(props.location.pathname);

  const fetchCustomMetrics = () => {
    getMonitorCustomMetricsByPublisherID(props.session.publisher.ID).then((data) => {
      if (data[0]) {
        setMonitorCustomMetrics(data[0]);
        setFetchedCustomMetrics(true);
      }
    });
  };

  const fetchAllMonitors = () => {
    getAllMonitors(props.session.publisher.ID).then(([monitors, err]) => {
      if (err) {
        console.error(err);
      } else {
        setAllMonitors(monitors as IMonitor[]);
        setFetchedAllMonitors(true);
      }
    });
  };

  const fetchMonitor = () => {
    getMonitor(loc.monitorid || '', props.session.publisher.ID).then(([m, err]) => {
      if (err) {
        console.error(err);
      } else if (m) {
        m.Name = obfuscateMonitorName(
          { Name: m.Name, ID: m.ID } as IMonitor,
          props.user.user.Username,
          m.Name,
        );
        if (
          m.MonitorCustomMetricID &&
          m.TargetedMetric === ELiveDataMetrics.METRICS_IDENTIFIER_CUSTOM_METRIC
        ) {
          m.targetedMetricType = TargetedMetricConditionCustom;
        } else {
          m.targetedMetricType = TargetedMetricConditionSingle;
        }
        const monitorCustomMetricsList = generateMonitorCustomMetricList(
          monitorCustomMetrics,
          m.MonitorCustomMetricID,
        ) as IMenuList;
        m.monitorDefinedMetricsList = generateMonitorMetricMenuList(
          false,
          m.TargetedMetric,
          undefined,
          m.TargetedObjectType,
        ) as IMenuList;
        m.monitorCustomMetrics = monitorCustomMetrics;
        m.monitorCustomMetricsList = monitorCustomMetricsList;
        m.MonitorCustomMetric = getSelectedMonitorCustomMetricFromList(
          monitorCustomMetricsList,
          monitorCustomMetrics,
        ) as IMonitorCustomMetric;
        setMonitor(m);
        setFetchedMonitor(true);
      }
    });
  };

  // get data from api
  useEffect(() => {
    // fetch all monitors
    if (!fetchedAllMonitors) {
      fetchAllMonitors();
    }
    // fetch Custom Metrics once only
    if (!fetchedCustomMetrics) {
      fetchCustomMetrics();
    }
    // only fetch Monitor once and after fetching custom metrics
    if (!fetchedMonitor && fetchedCustomMetrics) {
      fetchMonitor();
    }
  }, [fetchedMonitor, fetchedCustomMetrics, fetchedAllMonitors]);

  // only return view once monitor is populated after api calls
  if (monitor && fetchedMonitor && fetchedCustomMetrics && fetchedAllMonitors) {
    return <EditMonitor monitor={monitor} allMonitors={allMonitors} fetchMonitor={fetchMonitor} />;
  }
  return <LoadingView active={true} text='Loading...' />;
}

export const MonitorExistingView = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
  },
  MonitorExistingViewInner,
);
